import { render, staticRenderFns } from "./country-modify.vue?vue&type=template&id=5d3bb190"
import script from "./country-modify.vue?vue&type=script&lang=ts"
export * from "./country-modify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports